import { render, staticRenderFns } from "./MenuItemViewer.vue?vue&type=template&id=7b7a9c08"
import script from "./MenuItemViewer.vue?vue&type=script&lang=ts"
export * from "./MenuItemViewer.vue?vue&type=script&lang=ts"
import style0 from "./MenuItemViewer.vue?vue&type=style&index=0&id=7b7a9c08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports